.RenkuCard:hover img {
  content: url("../../assets/renkuColor.svg");
}
